import { render, staticRenderFns } from "./MainPageTopBanners.vue?vue&type=template&id=325ed0f2"
import script from "./MainPageTopBanners.vue?vue&type=script&lang=js"
export * from "./MainPageTopBanners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports